import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map,retryWhen, scan, delay} from 'rxjs/operators';
import { environment } from 'src/environments/environment';

// const endpoint = environment.apiEmailFromUrl;
const endpoint = environment.apiBaseUrl + '/asistente/formulario';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};


@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private http: HttpClient) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  public cargaDatosPersonales(ctx): Observable<any> {
    return this.http.post<any>(endpoint + '/cargaDatosPersonales', JSON.stringify(ctx),
      httpOptions).pipe(map(this.extractData)
      );
  }

  public cargarContactosCEA(ctx): Observable<any> {
    return this.http.post<any>(endpoint + '/cargarContactosCEA', JSON.stringify(ctx),
      httpOptions).pipe(map(this.extractData)
      );
  }

  public submitEmailForm(emailFormModel): Observable<any> {
    console.log("submitEmailForm():: emailFormModel: %s", JSON.stringify(emailFormModel));
    return this.http.post<any>(endpoint + '/submitEmailForm', JSON.stringify(emailFormModel),
      httpOptions).pipe(map(this.extractData)
      );
  }

  public submitEmailFormWithAttachments(emailFormModel): Observable<any> {
    return this.http.post<any>(endpoint + '/submitEmailFormWithAttachments', emailFormModel).pipe(map(this.extractData));
  }



  public uploadFiles(formData): Observable<any> {
    console.log("uploadFiles():: formData: %s", JSON.stringify(formData));
    return this.http.post<any>(endpoint + '/uploadFiles', formData, httpOptions).pipe(map(this.extractData)
    );
  }

  public obtenerSesionUsuario(urlSitio:string): Observable<string> {
    return this.http.get(urlSitio,{responseType: 'text',withCredentials: true }
    ).pipe( retryWhen(errors =>errors.pipe(scan((retryCount, error: HttpErrorResponse) => {
            console.log("retryCount",retryCount,error);
            // Si NO es 403 → no reintentar
            if (error.status !== 403) {
             // throw error;
            }

            // Si ya alcanzó el máximo → cortar
            if (retryCount >= 4) {
              throw error;
            }

            return retryCount + 1;

          }, 0),
          delay(2000) // espera 2 segundos antes de cada retry
        )
      )
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      console.log(`operation: ${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }
}
